import React from 'react'

import { withModalBuilder } from '../../../modules/modal/withModalBuilder'
import FileUploadBox from '../../views/widgets/FileUploadBox'
import { uploadImage } from '../../../modules/portal-remote/portalImageService'
import ImageCrop from '../../../modules/image-crop/ImageCrop'
import { toast } from 'react-toastify'
import styled from 'styled-components';

class ImageEditModal extends React.Component {
  state = {
    imageFile: undefined,
    croppedImageFile: undefined,
    isUploading: false,
  }

  componentDidMount() {
    this.setState({ imageFile: null })
  }

  handleImageChange = file => {
    this.setState({ imageFile: file })
  }

  handleImageCrop = file => {
    this.setState({ croppedImageFile: file })
  }

  handleImageCropCancel = () => {
    this.setState({
      imageFile: undefined,
      croppedImageFile: undefined,
    })
  }

  isUploadable = () => this.state.imageFile !== undefined

  handleUpload = async () => {
    if (!this.isUploadable()) return
    try {
      this.setState({ isUploading: true })

      const { portalId, currentImageId, longerWidth, onClose } = this.props
      const result = await uploadImage(
        portalId,
        this.state.croppedImageFile,
        currentImageId,
        longerWidth,
      )
      this.setState({ isUploading: true })
      if (!result || !result.ref) {
        throw Error('image ref is not returned from remote')
      }
      if (this.props.handleUpload) {
        this.props.handleUpload({ ref: result.ref, currentImageId, onClose })
      }
    } catch (error) {
      this.setState({ isUploading: false })
      toast.error(error.message)
    }
  }

  render() {
    const { onClose } = this.props

    return (
      <div className="card">
        {this.state.isUploading && (
          <UploadLoadingLayout>
            <span className="icon">
              <i className="fas fa-spinner fa-pulse" />
            </span>
          </UploadLoadingLayout>
        )}
        <header className="card-header">
          <p className="card-header-title">Edit Image</p>
          <a className="card-header-icon" aria-label="more options">
            <span className="icon">
              <i className="fas fa-angle-down" aria-hidden="true" />
            </span>
          </a>
        </header>
        <div className="card-content">
          <div className="content">
            {this.state.imageFile ? (
              <ImageCrop
                imageAspectRatio={this.props.imageAspectRatio || undefined}
                imageFile={this.state.imageFile}
                onImageCrop={this.handleImageCrop}
                onImageCropCancel={this.handleImageCropCancel}
              />
            ) : (
              <FileUploadBox
                name="file"
                label="Choose Image"
                accept="image/png,image/jpeg"
                onChange={this.handleImageChange}
              />
            )}
          </div>
        </div>
        <footer className="card-footer">
          <a className="card-footer-item button is-white" onClick={onClose}>
            กลับ
          </a>
          {this.state.croppedImageFile && (
            <a
              className="card-footer-item button is-primary"
              onClick={this.handleUpload}
            >
              อัพโหลด
            </a>
          )}
        </footer>
      </div>
    )
  }
}

const UploadLoadingLayout = styled.div`
    position: absolute;
    z-index: 99999;
    height: 100%;
    width: 100%;
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 3em;
    background: #fffd;
`

export default withModalBuilder({ isStatic: false })(ImageEditModal)



// WEBPACK FOOTER //
// ./src/components/templates/image-edit/ImageEditModal.js